import type { IAccordionData } from '@rumblefish/ui/src/components/Rumblefish23Theme/Accordion/CustomizedAccordion.types';

export const whatWeDoData = {
  mainText: 'Rumble Fish is not your typical software house',
  description: `We work in a highly organized, yet very flexible, manner
to make sure that your digital product is of the highest
quality. When working with you we take full
ownership of the technology and care deeply about
the success of your product.`,
};

export const AccordionData = (): IAccordionData[] => {
  return [
    {
      title: 'Passion for coding ',
      description:
        'When building teams we look for developers whose eyes light up when they talk about software development. We all share a passion for technology and strive for the quality of our work to reflect that.',
    },

    {
      title: 'Unique skillset ',
      description:
        'Our developers have extraordinary qualifications that make them valuable to any team or project they join. Whether your project requires Blockchain, AWS cloud, or FinTech expertise - we’ve got a perfect team for you.',
    },
    {
      title: 'Innovative thinking',
      description:
        'Our team goes the extra mile to make your product stand out. We don’t just settle for what might seem obvious - we always look for improvements and innovative solutions.',
    },
    {
      title: 'Agile approach',
      description: `Agility helps us deliver value to your project faster and leaves space for continuous improvements.`,
    },
    {
      title: 'Open communication',
      description:
        'We believe that openness and honesty go a long way. That’s why we choose a transparent approach to our processes - with Rumble Fish you’ll never be left in the dark, we keep our customers involved and informed about the status of the project throughout the journey.',
    },
  ];
};
